import type { WWeddingThemeView, WThemeGroupFontOptionsView } from '@zola/svc-web-api-ts-client';
import * as ActionType from '../actions/types/WeddingThemeActionTypes';
import type { WeddingThemeActionTypes } from '../actions/types/WeddingThemeActionTypes';

export type WeddingThemeReducerStateType = {
  busy: boolean;
  weddingTheme: WWeddingThemeView;
  themeFonts: WThemeGroupFontOptionsView | Record<string, never>;
};

const initialState = {
  busy: false,
  weddingTheme: {
    customization: {},
  },
  themeFonts: {},
};

const weddingThemeReducer = (
  state = initialState,
  action: WeddingThemeActionTypes
): WeddingThemeReducerStateType => {
  switch (action.type) {
    case ActionType.RECEIVE_WEDDING_THEME: {
      return Object.assign({}, state, { weddingTheme: action.payload.weddingTheme, busy: false });
    }
    case ActionType.RECEIVE_CUSTOMIZATION_VALUES: {
      const updatedWeddingTheme = { ...state.weddingTheme };
      updatedWeddingTheme.customization = action.payload.customization;
      return Object.assign({}, state, { weddingTheme: updatedWeddingTheme, busy: false });
    }
    case ActionType.RECEIVE_THEME_FONTS: {
      return Object.assign({}, state, { themeFonts: action.payload.themeFonts, busy: false });
    }
    default:
      return state;
  }
};

export default weddingThemeReducer;
